import React, { useState, useEffect } from "react";
import "./CustomOrderComponent.css";
import moment from "moment";
import { Apiurl } from "../../Pages/utils/page";
import Loader from "../Loader/Loader";
import { Button, Form, Modal } from "react-bootstrap";
import AddShippingModal from "./AddShippingModal";

const CustomOrderComponent = ({
  orderDetails,
  biddingDetails,
  loading,
  orderDetailsArray,
  activeButton,
  setActiveButton,
  deliveryTime,
  setDeliveryTime,
  shippingBy,
  setShippingBy,
  trackingNo,
  setTrackingNo,
  showModal,
  setShowModal,
  cancelOrderModal,
  setCancelOrderModal,
  showShipModal,
  shippingStatusModal,
  setShippingStatusModal,
  prefiledData,
  setPrefiledData,
  viewDetails,
  setViewDetails,
  prefiledShipData,
  setPrefiledShipData,
  handleOpenModal,
  handleCloseModal,
  handleOpenShipModal,
  handleCloseShipModal,
  handleOpenCancelOrderModal,
  handleShipStatusModal,
  handleAddAddress,
  handleStatusUpdate,
  handleViewDetails,
  handleOpenShipStatus,
  handleCloseCancelOrderModal,
  deliverStatusForm,
  setDeliveryStatusForm,
  errorMessage,
  setErrorMessage,
  setEditShipping,
  editShipping,
  handleConfirmDelivery,
  handleCancelOrder,
  cancelStatus,
  setCancelStatus,
  setTrackingData,
  setProductClickDetail,
  trackingData,
  handleCloseTrackingModal,
  setTrackingDetailModal,
  trackingDetailModal,
  errorMessageTracking,
  setErrorMessageTracking,
  productTrackingForm,
  setProductTrackingForm,
  handleCheckShipping,
  handleTrackingStatusUpdate,
  handleAddTrackingAddres,
  trackingAlreadyData,
}) => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      {loading === "order" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="btns-active-inactive-co">
              <button
                className={
                  activeButton === "order" ? "active-btn-co" : "inactive-btn-co"
                }
                onClick={() => setActiveButton("order")}
              >
                All Order Details
              </button>
              <button
                className={
                  activeButton === "bidding"
                    ? "active-btn-co"
                    : "inactive-btn-co"
                }
                onClick={() => setActiveButton("bidding")}
              >
                All Bidding Details
              </button>
            </div>
          </div>
        </div>

        {/* Order Details Section */}
        {activeButton === "order" ? (
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="vendor-tab-content_data">
                <div>
                  <div className="row">
                    <div className="col-lg-12 mb_commn_pd_0">
                      <div className="vendor_ordr_section">
                        {orderDetailsArray.map((item, index) => (
                          <div
                            className="vendor_order_border"
                            key={item?.OrderSummary?.OrderNumber || index}
                          >
                            <div className="vender_order_header">
                              <div className="row">
                                {/* Order Information */}
                                <div className="col-lg-4 col-sm-6 col-12 mb-order_spc">
                                  <p>
                                    <strong>Order No: </strong>
                                    {item?.OrderSummary?.OrderNumber}
                                  </p>
                                  <p>
                                    <strong>Transaction Id: </strong>

                                    {item?.OrderSummary?.TransactionId}
                                  </p>
                                  <p>
                                    <strong> Order Date: </strong>

                                    {moment(
                                      item?.OrderSummary?.OrderDate
                                    ).format("MM/DD/YYYY h:mm:ss A")}
                                  </p>
                                  <p>
                                    <strong>Status: </strong>

                                    <span
                                      style={{
                                        color: "#188653",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item?.OrderSummary?.OrderStatus}
                                    </span>
                                  </p>
                                </div>

                                {/* Customer Information */}
                                <div className="col-lg-2 col-sm-6 col-12 mb-order_spc">
                                  <p>{item?.CustomerInfo?.Name}</p>
                                </div>

                                {/* Address Information */}
                                <div className="col-lg-4 col-sm-6 col-12 mb-order_spc">
                                  <p>{item?.ShippingDetail?.AreaAndStreet}</p>
                                  <p>{item?.ShippingDetail?.City}</p>
                                  <p>{item?.ShippingDetail?.Locality},</p>
                                  <p>{item?.ShippingDetail?.Pincode}</p>
                                  <p>{item?.ShippingDetail?.State}</p>
                                </div>

                                {/* Order Summary */}
                                <div className="col-lg-2 col-sm-6 col-12">
                                  <p>
                                    <strong> Numbers of Items (Qty): </strong>

                                    <span className="item_pr_rgt">
                                      {item?.ProductDetail?.length}
                                    </span>
                                  </p>
                                  <p>
                                    <strong> Item Total (Rs): </strong>

                                    <span className="item_pr_rgt">
                                      {item?.Charges?.SubTotalPrice}
                                    </span>
                                  </p>
                                  <p>
                                    <strong> Tax (Rs): </strong>

                                    <span className="item_pr_rgt">
                                      {(item?.Charges?.SubTotalPrice *
                                        item?.Charges?.TaxInPercentage) /
                                        100}
                                    </span>
                                  </p>
                                  <p>
                                    <strong>Shipping (Rs): </strong>

                                    <span className="item_pr_rgt">
                                      {item?.Charges?.ShippingCharges}
                                    </span>
                                  </p>{" "}
                                  <p>
                                    <strong> Grand Total (Rs): </strong>

                                    <span className="item_pr_rgt">
                                      {(Number(item?.Charges?.SubTotalPrice) ||
                                        0) +
                                        (Number(item?.Charges?.SubTotalPrice) *
                                          Number(
                                            item?.Charges?.TaxInPercentage
                                          )) /
                                          100 +
                                        Number(item?.Charges?.ShippingCharges)}
                                    </span>
                                  </p>
                                  {/* <p>
                                    Promo Discount::{" "}
                                    <span className="item_pr_rgt">
                                      {item?.Charges?.ShippingCharges}
                                    </span>
                                  </p>
                                  <p>
                                    Amount Paid:{" "}
                                    <span className="item_pr_rgt">
                                      {item?.Charges?.AmountPaid}
                                    </span>
                                  </p> */}
                                </div>
                                <p>
                                  {viewDetails[index] ? (
                                    <>
                                      <a
                                        className="vendor_ordr_section_co"
                                        onClick={() => handleViewDetails(index)}
                                      >
                                        Hide Items{" "}
                                      </a>
                                    </>
                                  ) : (
                                    <>
                                      <a
                                        className="vendor_ordr_section_co"
                                        onClick={() => handleViewDetails(index)}
                                      >
                                        View Items{" "}
                                      </a>
                                    </>
                                  )}
                                </p>
                              </div>
                            </div>
                            {viewDetails[index] && (
                              <div>
                                <div className="vedr_pro_orde_detail">
                                  <div className="row">
                                    <div className="col-lg-12 col-sm-12 col-12 vendor_order_table_spc">
                                      <div className="table-responsive custom-table">
                                        <table
                                          className="table table-striped mb-0"
                                          cellspacing="0"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="product-thumbnail">
                                                Items
                                              </th>
                                              <th className="product-name">
                                                Description
                                              </th>
                                              <th className="product-price">
                                                MRP
                                              </th>
                                              <th className="product-price">
                                                Quantity
                                              </th>
                                              <th className="product-remove">
                                                Dispatch
                                              </th>
                                              <th className="product-remove">
                                                Status
                                              </th>
                                              {!item?.OrderSummary
                                                ?.IsOverAllTrackingDataAdded && (
                                                <th className="product-remove">
                                                  Shipping/Tracking
                                                </th>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item?.ProductDetail?.map((i) => {
                                              const imagesArray = JSON.parse(
                                                i.ImageSrc
                                              );

                                              const defaultImage =
                                                imagesArray.find(
                                                  (img) => img.Default
                                                );

                                              const imageUrl = defaultImage
                                                ? `${Apiurl()}/${
                                                    defaultImage.Images
                                                  }`
                                                : "";

                                              return (
                                                <tr>
                                                  <td className="vdr_pro_order_sum_img">
                                                    <a>
                                                      <img
                                                        src={imageUrl}
                                                        className="w-100"
                                                        onError={(e) => {
                                                          e.target.onerror =
                                                            null;
                                                          e.target.src =
                                                            "/Images/no-product-img-700.jpg";
                                                        }}
                                                      />
                                                    </a>
                                                  </td>
                                                  <td className="vdr_desc_pro_order">
                                                    <p>{i?.Name}</p>
                                                  </td>
                                                  <td className="vdr_order_mrp_wdt">
                                                    <p>{i?.UnitPrice}</p>
                                                  </td>
                                                  <td className="vdr_order_mrp_wdt">
                                                    <p>{i?.Unit}</p>
                                                  </td>
                                                  {i?.IsTrackingAdded ?
                                                   <td className="vdr_order_dispatch_wdt">
                                                   {i?.Status == "Delivered" ||
                                                   i?.Status == "Cancel" ? (
                                                     "--"
                                                   ) : (
                                                     <>
                                                       <div className="form-check">
                                                         <input
                                                           className="form-check-input"
                                                           type="radio"
                                                           name="flexRadioDefault"
                                                           value="OutForDelivery"
                                                           checked={
                                                             i?.Status ==
                                                             "OutForDelivery"
                                                           }
                                                           onChange={() => {
                                                             setCancelStatus(
                                                               " OutForDelivery"
                                                             );
                                                             setProductClickDetail(
                                                               i
                                                             );
                                                             handleOpenCancelOrderModal(
                                                               item
                                                             );
                                                           }}
                                                         />
                                                         <label
                                                           className="form-check-label"
                                                           htmlFor="flexRadioDefault1"
                                                         >
                                                           <p>
                                                             Out For Delivery
                                                           </p>
                                                         </label>
                                                       </div>
                                                       <div className="form-check">
                                                         <input
                                                           className="form-check-input"
                                                           type="radio"
                                                           name="flexRadioDefault"
                                                           value="Delivered"
                                                           checked={
                                                             i?.Status ==
                                                             "Delivered"
                                                           }
                                                           onChange={() => {
                                                             {
                                                               setCancelStatus(
                                                                 " Delivered"
                                                               );
                                                               setProductClickDetail(
                                                                 i
                                                               );
                                                               handleOpenCancelOrderModal(
                                                                 item
                                                               );
                                                             }
                                                           }}
                                                         />
                                                         <label
                                                           className="form-check-label"
                                                           htmlFor="flexRadioDefault1"
                                                         >
                                                           <p>Delivered</p>
                                                         </label>
                                                       </div>
                                                       <div className="form-check">
                                                         <input
                                                           className="form-check-input"
                                                           type="radio"
                                                           name="flexRadioDefault"
                                                           value="Cancel"
                                                           checked={
                                                             i?.Status ==
                                                             "Cancel"
                                                           }
                                                           onChange={() => {
                                                             setCancelStatus(
                                                               " Cancel"
                                                             );
                                                             handleOpenCancelOrderModal(
                                                               item
                                                             );
                                                           }}
                                                         />
                                                         <label
                                                           className="form-check-label"
                                                           htmlFor="flexRadioDefault3"
                                                         >
                                                           <p>Cancel Item</p>
                                                         </label>
                                                       </div>
                                                     </>
                                                   )}
                                                 </td>:
                                                 <td>
                                                  -
                                                 </td>
                                                 
                                                  }
                                                 
                                                  <td>
                                                    <p>{i?.Status}</p>
                                                  </td>
                                                  {!item?.OrderSummary
                                                    ?.IsOverAllTrackingDataAdded && (
                                                    <td>
                                                      <p>
                                                        <button
                                                          onClick={() => {
                                                            setProductTrackingForm(
                                                              {
                                                                DeliveryEstimatedTime:
                                                                  "",
                                                                ShippingBy: "",
                                                                PhoneNumber: "",
                                                                TrackingNumber:
                                                                  "",
                                                                Status: "",
                                                              }
                                                            );
                                                            handleCheckShipping(
                                                              item,
                                                              i
                                                            );
                                                            setTrackingData({
                                                              ...trackingData,
                                                              item: i,
                                                              obj: item,
                                                            });
                                                            setTrackingDetailModal(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          Add
                                                        </button>
                                                      </p>
                                                    </td>
                                                  )}
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* {item?.ProductDetail?.[0]?.Status ===
                                "Delivered" ? (
                                  <div className="vendor_footer_order">
                                    <button
                                      onClick={() =>
                                        handleOpenShipStatus(
                                          item,
                                          "ShippingStatus"
                                        )
                                      }
                                      type="button"
                                      className="common_btn btn-primary btn_vendor_can_ship mr-spc-5"
                                    >
                                      Shipping Status
                                    </button>
                                  </div>
                                ) : ( */}
                                <div className="vendor_footer_order">
                                  <div className="row">
                                    <div className="col-lg-7 col-sm-9 col-12 gap-3">
                                      {item?.OrderSummary
                                        ?.IsOverAllTrackingDataAdded && (
                                        <button
                                          onClick={() =>
                                            handleOpenShipModal(item)
                                          }
                                          type="button"
                                          className="common_btn btn-primary btn_vendor_can_ship mr-spc-5"
                                        >
                                          Shipping Detail &amp; Status Update
                                        </button>
                                      )}

                                      {item?.ProductDetail?.every(
                                        (product) =>
                                          product.Status === "Delivered"
                                      ) &&
                                      item?.OrderSummary?.OrderStatus !==
                                        "Delivered" ? (
                                        <>
                                          <button
                                            onClick={() =>
                                              handleOpenCancelOrderModal(item)
                                            }
                                            type="button"
                                            className="common_btn btn-danger btn_vendor_can_ship mr-spc-5"
                                          >
                                            Cancel Whole Items
                                          </button>
                                          <button
                                            type="button"
                                            className="common_btn ml-2 mt-spc-5 btn-success"
                                            onClick={() =>
                                              handleStatusUpdate(
                                                item,
                                                "Delivered"
                                              )
                                            }
                                          >
                                            Update Order Status
                                          </button>
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                {/* )} */}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="vendor-tab-content_data">
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="admin_winner_wraper">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="table-responsive custom-table">
                          <table
                            className="table table-striped"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Action</th>
                                <th>Published By</th>
                                <th>Product Name</th>
                                <th>Product Image</th>
                                <th>User Image</th>
                                <th>User Name</th>
                                <th>Address</th>
                                <th>Winning Date</th>
                                <th>Process</th>
                              </tr>
                            </thead>
                            <tbody>
                              {biddingDetails.map((item, index) => {
                                const image = item?.UserImageURL?.split('"');
                                const imageUrl = `${Apiurl()}/${image?.[1]}`;

                                const imagesArray = JSON.parse(
                                  item.ProductImageURL
                                );
                                const defaultImage = imagesArray?.find(
                                  (img) => img.Default
                                );
                                const imageUrlProduct = defaultImage
                                  ? `${Apiurl()}/${defaultImage.Images}`
                                  : "";

                                return (
                                  <tr key={index}>
                                    <td>
                                      <button
                                        type="button"
                                        className="common_btn view-data-btn"
                                        onClick={() => handleOpenModal(item)}
                                      >
                                        Ship
                                      </button>
                                    </td>
                                    <td>{item?.Username}</td>
                                    <td>{item?.ProductName}</td>
                                    <td className="ven_win_pro_img">
                                      <img
                                        src={imageUrlProduct}
                                        alt="Product"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "/Images/no-product-img-700.jpg";
                                        }}
                                      />
                                    </td>
                                    <td className="ven_win_user_img">
                                      <img
                                        src={imageUrl}
                                        alt="User"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "/Images/unisexImage.jpeg";
                                        }}
                                      />
                                    </td>
                                    <td>{item?.Username}</td>
                                    <td>{item?.Address}</td>
                                    <td>
                                      {moment(item?.Date).format("MM/DD/YYYY")}
                                    </td>
                                    <td>{item?.ShippingStatus}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal show={showModal} onHide={handleCloseModal} backdrop="static">
        <Modal.Header className="add-address-close-icon" closeButton />
        <Modal.Body>
          <Form className="add-Address-main-container-co">
            <div className="etime-deleverby">
              <Form.Group controlId="formDelivery" className="d-e-time">
                <Form.Label>Delivery Estimate Time</Form.Label>
                <Form.Control
                  type="date"
                  value={deliveryTime}
                  onChange={(e) => setDeliveryTime(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formShippingBy" className="d-e-time">
                <Form.Label>Shipping By</Form.Label>
                <Form.Control
                  type="text"
                  value={shippingBy}
                  onChange={(e) => setShippingBy(e.target.value)}
                />
              </Form.Group>
            </div>
            <Form.Group controlId="formTrackingNo">
              <Form.Label>Tracking No</Form.Label>
              <Form.Control
                type="text"
                value={trackingNo}
                onChange={(e) => setTrackingNo(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="Add-address-modal-save-button"
            variant="primary"
            onClick={() => {
              handleAddAddress();
              handleStatusUpdate();
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Shipping Deatils Modal  */}
      <Modal
        show={showShipModal}
        onHide={handleCloseShipModal}
        backdrop="static"
        className="ship-nmodal-main"
      >
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Order Id: {prefiledShipData?.OrderSummary?.OrderNumber}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container-co">
            <h6 className="p-name-ship">
              Product Name : {prefiledShipData?.ProductDetail?.[0]?.Name}
            </h6>
            <div className="item-status-ship">
              <p>Item Status : </p>{" "}
              <p className="order-status-ship">
                {" "}
                {prefiledShipData?.ProductDetail?.[0]?.Status}
              </p>
            </div>
            <div className="etime-deleverby">
              <Form.Group controlId="formDelivery" className="">
                <Form.Label>Delivery Estimate Time</Form.Label>
                <Form.Control
                  type="date"
                  value={deliverStatusForm?.DeliveryEstimatedTime}
                  onChange={(e) => {
                    setDeliveryStatusForm({
                      ...deliverStatusForm,
                      DeliveryEstimatedTime: e.target.value,
                    });
                    setErrorMessage({
                      ...errorMessage,
                      DeliveryEstimatedTime: "",
                    });
                  }}
                />
              </Form.Group>
              <Form.Group controlId="formShippingBy" className="">
                <Form.Label>Shipping By</Form.Label>
                <Form.Control
                  type="text"
                  value={deliverStatusForm?.ShippingBy}
                  onChange={(e) => {
                    setDeliveryStatusForm({
                      ...deliverStatusForm,
                      ShippingBy: e.target.value,
                    });
                    setErrorMessage({ ...errorMessage, ShippingBy: "" });
                  }}
                />
              </Form.Group>

              <Form.Group controlId="formTrackingNo">
                <Form.Label>Phone No</Form.Label>
                <Form.Control
                  type="text"
                  value={deliverStatusForm?.PhoneNumber}
                  onChange={(e) => {
                    setDeliveryStatusForm({
                      ...deliverStatusForm,
                      PhoneNumber: e.target.value,
                    });
                    setErrorMessage({ ...errorMessage, PhoneNumber: "" });
                  }}
                />
              </Form.Group>

              <Form.Group controlId="formTrackingNo">
                <Form.Label>Tracking No</Form.Label>
                <Form.Control
                  type="text"
                  value={deliverStatusForm?.TrackingNumber}
                  onChange={(e) => {
                    setDeliveryStatusForm({
                      ...deliverStatusForm,
                      TrackingNumber: e.target.value,
                    });
                    setErrorMessage({ ...errorMessage, TrackingNumber: "" });
                  }}
                />
              </Form.Group>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="Add-address-modal-save-button-ship">
          <Button
            className="view-data-btn-ship"
            variant="primary"
            onClick={() => {
              handleAddAddress();
              handleStatusUpdate();
            }}
          >
            Update Order With Shipping Detail
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Cancel Order Modal  */}
      <Modal
        show={cancelOrderModal}
        onHide={handleCloseCancelOrderModal}
        backdrop="static"
        className="cancelorder-nmodal-main"
      >
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Confirm ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container-co">
            <div className="item-status-ship">
              <p>
                {cancelStatus?.trim() === "OutForDelivery"
                  ? "Are you sure you want to update status to out for delivery ?"
                  : cancelStatus?.trim() === "Delivered"
                  ? "Are you sure you want to update status to delivered ?"
                  : "Are you sure you want to update status to cancel ?"}
              </p>
            </div>
            <div className="etime-deleverby"></div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="Add-address-modal-save-button-ship">
          <Button
            className="view-data-btn-ship"
            variant="primary"
            onClick={() => {
              handleConfirmDelivery();

              // handleAddAddress();
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Shipping Status Modal  */}
      <Modal
        show={shippingStatusModal}
        onHide={handleShipStatusModal}
        backdrop="static"
        className="ship-nmodal-main"
      >
        <Modal.Header className="add-address-close-icon" closeButton>
          <Modal.Title className="shipping-address-heading">
            Order Id: {prefiledData?.OrderId}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="add-Address-main-container-co">
            {prefiledShipData?.ProductDetail?.map((i) => {
              return (
                <div>
                  <h6 className="p-name-ship">Product Name : {i?.Name}</h6>
                  <div className="item-status-ship">
                    <p>Item Status : </p>{" "}
                    <p className="order-status-ship"> {i?.Status}</p>
                  </div>
                  <hr></hr>
                </div>
              );
            })}

            {editShipping ? (
              <>
                <div className="etime-deleverby">
                  <Form.Group controlId="formDelivery" className="">
                    <Form.Label>Delivery Estimate Time</Form.Label>
                    <Form.Control
                      type="date"
                      value={moment(
                        deliverStatusForm?.DeliveryEstimatedTime
                      ).format("YYYY-MM-DD")}
                      onChange={(e) => {
                        setDeliveryStatusForm({
                          ...deliverStatusForm,
                          DeliveryEstimatedTime: e.target.value,
                        });
                        setErrorMessage({
                          ...errorMessage,
                          DeliveryEstimatedTime: "",
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group controlId="formShippingBy" className="">
                    <Form.Label>Shipping By</Form.Label>
                    <Form.Control
                      type="text"
                      value={deliverStatusForm?.ShippingBy}
                      onChange={(e) => {
                        setDeliveryStatusForm({
                          ...deliverStatusForm,
                          ShippingBy: e.target.value,
                        });
                        setErrorMessage({ ...errorMessage, ShippingBy: "" });
                      }}
                    />
                  </Form.Group>

                  <Form.Group controlId="formTrackingNo">
                    <Form.Label>Phone No</Form.Label>
                    <Form.Control
                      type="text"
                      value={deliverStatusForm?.PhoneNumber}
                      onChange={(e) => {
                        setDeliveryStatusForm({
                          ...deliverStatusForm,
                          PhoneNumber: e.target.value,
                        });
                        setErrorMessage({ ...errorMessage, PhoneNumber: "" });
                      }}
                    />
                  </Form.Group>

                  <Form.Group controlId="formTrackingNo">
                    <Form.Label>Tracking No</Form.Label>
                    <Form.Control
                      type="text"
                      value={deliverStatusForm?.TrackingNumber}
                      onChange={(e) => {
                        setDeliveryStatusForm({
                          ...deliverStatusForm,
                          TrackingNumber: e.target.value,
                        });
                        setErrorMessage({
                          ...errorMessage,
                          TrackingNumber: "",
                        });
                      }}
                    />
                  </Form.Group>
                  {/* <Form.Group controlId="formTrackingNo">
                    <Form.Label>Status</Form.Label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="Status"
                        value="InProgress"
                        checked={deliverStatusForm?.Status === "InProgress"}
                        onChange={(e) => {
                          setDeliveryStatusForm({
                            ...deliverStatusForm,
                            Status: e.target.value,
                          });
                          setErrorMessage({
                            ...errorMessage,
                            Status: "",
                          });
                        }}
                      />
                      <label className="form-check-label" htmlFor="InProgress">
                        <p>In Progress</p>
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="Status"
                        value="OutForDelivery"
                        checked={deliverStatusForm?.Status === "OutForDelivery"}
                        onChange={(e) => {
                          setDeliveryStatusForm({
                            ...deliverStatusForm,
                            Status: e.target.value,
                          });
                          setErrorMessage({
                            ...errorMessage,
                            Status: "",
                          });
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="OutForDelivery"
                      >
                        <p>Out for Delivery</p>
                      </label>
                    </div>
                  </Form.Group> */}
                </div>
              </>
            ) : (
              <div className="etime-deleverby">
                <Form.Group controlId="formDelivery" className="col-lg-3">
                  <strong>Estimated Delivery time</strong>
                  <p>
                    {moment(prefiledData?.DeliveryEstimatedTime).format(
                      "YYYY-MM-DD"
                    )}
                  </p>
                </Form.Group>
                <Form.Group controlId="formShippingBy" className="col-lg-3">
                  <strong>Shipping By</strong>
                  <p>{prefiledData?.ShippingBy}</p>
                </Form.Group>

                <Form.Group controlId="formTrackingNo" className="col-lg-3">
                  <strong>Phone No</strong>
                  <p>{prefiledData?.PhoneNumber}</p>
                </Form.Group>

                <Form.Group controlId="formTrackingNo" className="col-lg-3">
                  <strong>Tracking No</strong>
                  <p>{prefiledData?.TrackingNumber}</p>
                </Form.Group>
              </div>
            )}
          </Form>
          {editShipping ? (
            <div className="row">
              <div className="col-lg-6 col-8">
                <div className="form-group mt-2">
                  <button
                    type="button"
                    className="common_btn view-data-btn"
                    onClick={() => {
                      handleAddAddress();
                      // handleStatusUpdate();
                    }}
                  >
                    Update Order With Shipping Detail
                  </button>
                </div>
              </div>
              <div className="col-lg-6 col-4">
                <div className="form-group mt-2">
                  <button
                    type="button"
                    className="common_btn btn-primary pull-right"
                    onClick={() => setEditShipping(false)}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          ) : prefiledData &&
            prefiledData?.Status !== "Delivered" &&
            prefiledData?.Status !== "Cancel" ? (
            <button
              type="button"
              className="common_btn btn-primary mt-2"
              onClick={() => setEditShipping(true)}
            >
              Edit Shipping Detail &amp; Order Status Update
            </button>
          ) : null}
          {editShipping ? (
            <div className="etime-deleverby">
              <Form.Group controlId="formDelivery" className="col-lg-3">
                <strong>Estimated Delivery time</strong>
                <p>
                  {moment(prefiledData?.DeliveryEstimatedTime).format(
                    "YYYY-MM-DD"
                  )}
                </p>
              </Form.Group>
              <Form.Group controlId="formShippingBy" className="col-lg-3">
                <strong>Shipping By</strong>
                <p>{prefiledData?.ShippingBy}</p>
              </Form.Group>

              <Form.Group controlId="formTrackingNo" className="col-lg-3">
                <strong>Phone No</strong>
                <p>{prefiledData?.PhoneNumber}</p>
              </Form.Group>

              <Form.Group controlId="formTrackingNo" className="col-lg-3">
                <strong>Tracking No</strong>
                <p>{prefiledData?.TrackingNumber}</p>
              </Form.Group>
            </div>
          ) : null}
        </Modal.Body>
        {/* {!editShipping ? (
          <Modal.Footer className="Add-address-modal-save-button-ship">
            {prefiledData?.Status == "Delivered" ? (
              <p style={{ color: "#198754", marginTop: "10px" }}>Delivered!</p>
            ) : (
              <Button
                className="view-data-btn-ship"
                variant="primary"
                onClick={handleConfirmDelivery}
              >
                Order Shipping Status Update (Confirm When Order is Delivered)
              </Button>
            )}
          </Modal.Footer>
        ) : null} */}
      </Modal>

      {/* Add Shippign Modal */}
      <AddShippingModal
        trackingDetailModal={trackingDetailModal}
        handleCloseTrackingModal={handleCloseTrackingModal}
        trackingData={trackingData}
        setProductTrackingForm={setProductTrackingForm}
        productTrackingForm={productTrackingForm}
        setErrorMessageTracking={setErrorMessageTracking}
        errorMessageTracking={errorMessageTracking}
        handleAddTrackingAddres={handleAddTrackingAddres}
        handleTrackingStatusUpdate={handleTrackingStatusUpdate}
        trackingAlreadyData={trackingAlreadyData}
        editShipping={editShipping}
        setEditShipping={setEditShipping}
      />
    </div>
  );
};
export default CustomOrderComponent;
